import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

import { CompaniesService } from "../../../services/companies.service";
import { CompanyProducts } from "src/models/phoenix";
import { AuthNewService } from "src/auth/services/auth-new.service";
import { AuthSessionPayload, CompaniesEnabled } from "./apai-enabled.service";

@Injectable({
  providedIn: "root",
})
export class VatEnabledService {
  enabledCompaniesSubject = new ReplaySubject<CompaniesEnabled>();
  enabledCompanies$ = this.enabledCompaniesSubject.asObservable();
  enabledCompanies: CompaniesEnabled;

  constructor(
    private companiesService: CompaniesService,
    private auth: AuthNewService,
  ) {}

  fetchConfig() {
    const payload = this.getAuthPayload();

    if (!payload) {
      console.warn("No authenticated user data found");
      return;
    }

    const companiesIds = payload.companiesIds || [];
    const isAdmin = this.hasRole(payload.role, "Admin");

    if (payload.userId) {
      const entry = localStorage.getItem(
        "vat_enabled_companies" + payload.userId
      );

      if (entry) {
        try {
          const parsed: CompaniesEnabled = JSON.parse(entry);
          this.enabledCompanies = parsed;

          this.enabledCompaniesSubject.next(parsed);
        } catch (_) {
          console.error("Error parsing stored VAT enabled companies data");
        }
      }
    }

    const companyIds = isAdmin ? [] : companiesIds;

    const sub = this.companiesService.companiesWithEnabledProducts(
      CompanyProducts.vat,
      companyIds
    );
    sub.subscribe({
      next: (companies) => {
        const enabledCompaniesData: CompaniesEnabled = {
          userId: Number(payload.userId),
          userRole: payload.role,
          companies,
        };

        this.enabledCompanies = enabledCompaniesData;
        this.enabledCompaniesSubject.next(enabledCompaniesData);

        localStorage.setItem(
          "vat_enabled_companies" + payload.userId,
          JSON.stringify(enabledCompaniesData)
        );
      },
      error: (error) => {
        console.error("Error fetching company enabled products (VAT):", error);
      },
    });
    return sub;
  }

  private getAuthPayload(): AuthSessionPayload | null {
    const payload = this.auth.userValue?.payload;
    if (!payload) return null;

    return {
      userId: payload.userId,
      role: payload.role?.toString(),
      companiesIds: payload.companiesIds || [],
    };
  }

  private hasRole(value: string | undefined, role: string) {
    return value?.toLowerCase() === role.toLowerCase();
  }
}
